import { RoadQueryParams } from "./query.types";
import { SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { Nullable } from "shared/lib/typeCheck.lib";
import { t } from "shared/localization/localization";

export const piecesText = (pieces: number): string => {
  return `${pieces} ${pieces > 1 ? t("pieces") : t("piece")}`;
};

type CreateRoadSearchQueryParamsParams = {
  requestType: "openedCard" | "updateCard" | "search";
  override?: Partial<RoadQueryParams>;
};

export const createRoadSearchQueryParams = ({
  requestType,
  override,
}: CreateRoadSearchQueryParamsParams): RoadQueryParams | null => {
  const reference: Nullable<SearchReferenceDTO> = override?.number;
  const carrier: Nullable<SearchReferenceDTO> = override?.carrier;
  const type: Nullable<SearchReferenceDTO> = override?.type;

  if (!reference) return null;

  switch (requestType) {
    case "openedCard":
      return Object.assign({
        number: reference,
        ...(carrier ? { carrier } : {}),
        ...(type ? { type } : {}),
      });
    case "search":
    default:
      return Object.assign({ number: reference, ...(carrier ? { carrier } : {}), ...(type ? { type } : {}) });
  }
};
